import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Buildpurpose(props) {
  return (
    <div className="services_orange_bg p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center order-2 order-md-1"
          >
            <StaticImage
              src="../../images/services/infrastructure/streamline.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="services_title my-auto order-1 order-md-2"
          >
            <h2>
              Streamline Business Performance with Efficient Infrastructure
              Migration
            </h2>
            <p>
              Our infrastructure migration services are streamlined to help your
              business processes operate flawlessly with improved performance
              and efficiency. Our experienced staff is trained in advanced
              technology and polished migration techniques that automate all
              processes, identify new environments, and make sure you keep on
              going with ease. Even if you're migrating legacy systems or
              adapting to cloud architecture, let us reveal everything that will
              be transparent for you by providing a highly customized migration
              process in harmony with your business needs.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Buildpurpose;
